export default __webpack_public_path__ + "static/media/airdockz-blk-banner-2.7d23e177.jpg";